import React from "react";
import "./Footer.css";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { GrInstagram } from "react-icons/gr";
const Footer = () => {
  return (
    <footer>
      {/*  <a href="/" className="footer__logo">
        Abubakar Mahboob
      </a>
      <ul className="permalinks">
        <li>
          <a href="/">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Expeirience</a>
        </li>
        <li>
          <a href="#service">Services</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="#testmonial">Testimonial</a>
        </li>
        <li>
          <a href="#conntact">Contact</a>
        </li>
      </ul> */}
      <div className="footer__socials">
        <a
          href="https://www.linkedin.com/in/abubakar-mahboob/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <BsLinkedin />
        </a>
        <a
          href="https://github.com/AbubakarChaudhary"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaGithub />
        </a>
        <a
          href="https://instagram.com/ab_tech_solutions_?igshid=MzMyNGUyNmU2YQ=="
          target="_blank"
          rel="noopener noreferrer"
        >
          <GrInstagram />
        </a>
      </div>
      <div className="footer__copywrite">
        <small>&copy;Abubakar Mahboob Created by Abubakar</small>
      </div>
    </footer>
  );
};

export default Footer;
